const variantSizeStylesMap = {
  small: {
    buttonSize: {
      padding: 'space20'
    },
    iconSize: 'medium'
  },
  medium: {
    buttonSize: {
      padding: 'space20'
    },
    iconSize: 'large'
  },
  large: {
    buttonSize: {
      padding: 'space30'
    },
    iconSize: 'large'
  }
};
const buttonSizeStylesMap = {
  small: {
    padding: 'space0'
  },
  medium: {
    padding: 'space20'
  },
  large: {
    padding: 'space30'
  }
};
const getIconButtonStyles = size => {
  return buttonSizeStylesMap[size] || buttonSizeStylesMap.small;
};
const getVariantSizeStyles = size => {
  return variantSizeStylesMap[size] || variantSizeStylesMap.large;
};
const getTertiaryProps = variant => {
  return variant === 'tertiary' ? {
    variant: 'unstyled',
    variantColor: 'carbon'
  } : {};
};
const checkForSemanticVariant = variant => ['primary', 'secondary', 'tertiary'].includes(variant);

export { checkForSemanticVariant, getIconButtonStyles, getTertiaryProps, getVariantSizeStyles, variantSizeStylesMap };
